import axios from "../utils/axios-interceptor";

export const forgotPasswordApi = async(payload) => {
  try {
    const res = await axios.post("/forgot-password", payload);
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(`Error: ${error.message}`);
  }
}
